import { useEffect, useRef } from "react";

export default function useOnClickOutside<TElement extends HTMLElement>(callback: () => void) {
    const ref = useRef<TElement>(null);

    useEffect(() => {
        const copy = ref.current;
        if (!copy) return;

        const abortController = new AbortController();

        copy.addEventListener(
            "click",
            (evt: MouseEvent) => {
                const rect = copy?.getBoundingClientRect();
                if (!rect) return;

                const isInElement =
                    rect.top <= evt.clientY &&
                    evt.clientY <= rect.top + rect.height &&
                    rect.left <= evt.clientX &&
                    evt.clientX <= rect.left + rect.width;

                if (!isInElement) callback();
            },
            { signal: abortController.signal },
        );

        return () => {
            if (copy) abortController.abort();
        };
    }, [callback]);

    return ref;
}
